module.exports = __webpack_public_path__ + "public/images/secret-image2.85f57cd90bc6ad6891b9999d74c0d9f5.jpg";